<div class="top-buttons-container">
  <div class="top-button">
    <button
      mat-icon-button
      color="primary"
      (click)="onAddWidget()"
      class="wtr-button-primary"
      [matTooltip]="T_SCOPE + '.buttons.add-widget' | translate | lowercase"
      [style.visibility]="dashboardGroupPermissions?.canCreate ? 'visible' : 'hidden'"
    >
      <wlm-icon [icon]="'add'"></wlm-icon>
    </button>
    <button
      mat-icon-button
      color="primary"
      (click)="onSaveDashboard()"
      class="wtr-button-primary"
      [matTooltip]="T_SCOPE + '.buttons.save-dashboard' | translate | lowercase"
      [style.visibility]="dashboardGroupPermissions?.canCreate ? 'visible' : 'hidden'"
    >
      <wlm-icon [icon]="'save'"></wlm-icon>
    </button>
  </div>
</div>
<wlm-dynamic-layout
  *ngIf="dynamicLayoutSettingsLoadOptions"
  [allowEmptyRoot]="allowEmptyRoot"
  [specificLevel]="specificLevel"
  [settingsToLoad]="dynamicLayoutSettingsLoadOptions"
  (settingsChanged)="onLayoutSettingsChanged($event)"
></wlm-dynamic-layout>
